﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
import * as nouislider from 'nouislider';

import * as FilePond from 'filepond';

import FilePondPluginFileEncode from '../../../plugins/filepond-plugin-file-encode';
import FilePondPluginFileValidateType from '../../../plugins/filepond-plugin-file-validate-type';

import tpl_officePowerPoint from './tpl/officePowerPoint.html';

import View_DialogWaiting2 from '../../../../lib/views/dialogWaiting2/dialogWaiting2';
import View_DialogWaiting from '../../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Empty from '../../../../lib/entities/empty';


import config from '../../../../common/config';

export default Marionette.ItemView.extend({
    dialogRegion: '#officePowerPoint_modal',
    errors: [],
    getTemplate: function () {
        return tpl_officePowerPoint({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        //this.listenTo(this.model, 'change', this.render, this);
    },
    ui: {
        'officePowerPoint_input_File_Name': '#officePowerPoint_input_File_Name',
        'officePowerPoint_filePond': '#officePowerPoint_filePond',
        'officePowerPoint_checkbox_EnablePlay': '#officePowerPoint_checkbox_EnablePlay',
        'officePowerPoint_group_Duration': '#officePowerPoint_group_Duration',
        'officePowerPoint_input_Duration': '#officePowerPoint_input_Duration',
        'officePowerPoint_label_Duration': '#officePowerPoint_label_Duration',
        'module_input_ModuleMargin_Top': '#module_input_ModuleMargin_Top',
        'module_input_ModuleMargin_Bottom': '#module_input_ModuleMargin_Bottom',
        'module_input_ModuleMargin_Left': '#module_input_ModuleMargin_Left',
        'module_input_ModuleMargin_Right': '#module_input_ModuleMargin_Right'
    },
    events: {
        'click #officePowerPoint_btn01': 'onBtn01',
        'click #officePowerPoint_btn02': 'onBtn02'
    },
    onRender: function () {
        this.setupEnableType();
    },
    getFileType: function (mimeType) {
        var ret = 'pptx';

        switch (mimeType) {
            case 'application/vnd.ms-powerpoint': ret = 'ppt'; break;
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation': ret = 'pptx'; break;
            case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow': ret = 'ppsx'; break;
            case 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': ret = 'ppsm'; break;
            case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12' : ret = 'pptm'; break;
        }

        return ret;
    },
    base64MimeType: function (encoded) {
        var result = null;

        if (typeof encoded !== 'string') {
            return result;
        }

        var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

        if (mime && mime.length) {
            result = mime[1];
        }

        return result;
    },
    onAttach() {
        var self = this;

        FilePond.registerPlugin(
            FilePondPluginFileValidateType,
            FilePondPluginFileEncode,
        );

        var labelIdle = resources.X101435 + ' <span class="filepond--label-action">' + resources.X101437 + '</span>';

        var pond = FilePond.create(this.ui.officePowerPoint_filePond[0], {
            labelIdle: [
                labelIdle,
                ''
            ],
            acceptedFileTypes: [
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
                'application/vnd.ms-powerpoint',
                'application/vnd.ms-powerpoint',
                'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
                'application/vnd.ms-powerpoint.template.macroEnabled.12',
                'application/vnd.ms-powerpoint.addin.macroEnabled.12',
                'application/vnd.openxmlformats-officedocument.presentationml.template',
                'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
            ],
            allowMultiple: false,

            onaddfile: (err, fileItem) => {
                if (err == null) {
                    var dialogWaitingModel = new Entities_Empty.Model();
                    dialogWaitingModel.attributes.Title = resources.X100322;
                    dialogWaitingModel.attributes.Text = resources.X100301;
                    dialogWaitingModel.attributes.Button = resources.X100279;

                    var dialogWaiting = new View_DialogWaiting2({ model: dialogWaitingModel, parent: self });
                    var callback = function (options) {
                        this.stopListening(dialogWaiting, "dialog:okclicked", callback);
                    }
                    this.listenTo(dialogWaiting, "dialog:okclicked", callback);
                    app.dialogRegion2.show(dialogWaiting);


                    //console.log(err, fileItem.getMetadata('resize'));
                    var base64 = fileItem.getFileEncodeDataURL();
                    var mimeType = self.base64MimeType(base64);
                    var fileData = base64.split(',')[1];
                    //var base64 = fileItem.getFileEncodeBase64String();

                    var tmpModel = new self.collection.model();
                    tmpModel.attributes.AuthUserId = config.authUserId();
                    tmpModel.attributes.FileData = fileData;
                    tmpModel.attributes.FileMimeType = mimeType;
                    tmpModel.attributes.FileUpdate = true;

                    var filename = 'officePowerPoint' + '_' + + new Date().getTime() + '.' + self.getFileType(mimeType);
                    tmpModel.attributes.Filename = filename;//fileItem.filename;
                    tmpModel.attributes.Name = fileItem.filename;
                    tmpModel.attributes.EventId = self.options.parent.options.templateModel.attributes.EventId;
                    tmpModel.attributes.TemplateId = self.options.parent.options.templateModel.attributes.id;
                    tmpModel.attributes.ModuleRegion = self.options.parent.model.attributes.ModuleRegion;
                    tmpModel.attributes.ModuleDiv = self.options.parent.model.attributes.ModuleDiv;
                    tmpModel.attributes.ModuleType = self.options.parent.model.attributes.ModuleType;

                    self.collection.create(tmpModel, {
                        wait: true,
                        success: function (response) {
                            self.model.attributes.id = response.attributes.id;
                            self.model.attributes.InfoFile_id = response.attributes.id;
                            self.model.attributes.InfoFile_FileUrl = response.attributes.FileUrl;
                            self.model.attributes.InfoFile_Name = response.attributes.Name;

                            //dialogWaiting.triggerMethod('dialog:close');

                            //self.collection.fullCollection.sort();
                            //self.collection.getFirstPage({ fetch: false });
                            pond.removeFile(fileItem);

                            self.ui.officePowerPoint_input_File_Name.val(self.model.attributes.InfoFile_Name);
                            //self.model.trigger('change');
                            dialogWaiting.triggerMethod('dialog:close');
                        }
                    });
                }
            }
        });

        this.ui.officePowerPoint_input_Duration.durationPicker({
            translations: {
                day: resources.X101498,
                hour: resources.X101499,
                minute: resources.X101500,
                second: resources.X101501,
                days: resources.X101502,
                hours: resources.X101503,
                minutes: resources.X101504,
                seconds: resources.X101505,
            },
            showSeconds: true,
            onChanged: function (newVal) {
                self.ui.officePowerPoint_label_Duration.text(newVal);
                self.model.set({
                    Duration: newVal
                });
            }
        });

        $('.bdp-block.hidden').css('display', 'none');

        this.ui.officePowerPoint_group_Duration.find('.input-sm').width(90);
    },
    setupEnableType: function () {
        var checked = this.model.attributes.EnablePlay == 1 ? true : false;
        this.ui.officePowerPoint_checkbox_EnablePlay.attr('checked', checked);
    },
    onBtn01: function () {
        var self = this;

        self.setModel();

        var callback = function () {
            self.trigger("dialog:close");
            self.triggerMethod('dialog:btn01clicked', "msg");
        }

        this.validate(callback);
    },
    onBtn02: function () {
        this.triggerMethod('dialog:btn02clicked', "msg");
        this.trigger("dialog:close");
    },
    showErrors: function (errors) {
        _.each(errors, function (error) {
            var controlGroup = this.$('.' + error.name);
            controlGroup.addClass('error');
            controlGroup.find('.help-inline').text(error.message);
        }, this);
    },
    hideErrors: function () {
        this.$('.control-group').removeClass('error');
        this.$('.help-inline').text('');

        this.errors = [];
    },
    validate: function (callback) {
        var self = this;
        this.hideErrors();
        callback();
    },
    setModel: function () {
        var EnablePlay = this.model.attributes.EnablePlay;
        this.ui.officePowerPoint_checkbox_EnablePlay.is(':checked') ? EnablePlay = 1 : EnablePlay = 0;

        this.model.set({
            EnablePlay: EnablePlay,
            ModuleMargin_Top: this.ui.module_input_ModuleMargin_Top.val(),
            ModuleMargin_Bottom: this.ui.module_input_ModuleMargin_Bottom.val(),
            ModuleMargin_Left: this.ui.module_input_ModuleMargin_Left.val(),
            ModuleMargin_Right: this.ui.module_input_ModuleMargin_Right.val()
        });
    }
});